export default "__VITE_ASSET__DPOQcgWm__"